// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialShare_root__Fu5_L","shareLabel":"SocialShare_shareLabel__7A8WX","shareLink":"SocialShare_shareLink__ddbOJ","shareIcon":"SocialShare_shareIcon__lN6mw"};